import React from "react";
import { useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';

export const withToast = WrappedComponent => {
  return props => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    const showSuccess = (message) => {
      enqueueSnackbar(message, {
        variant: "success",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <CloseIcon 
            type="button"
            aria-label="Close"
            className="clickable"
            onClick={() => closeSnackbar(key)} />
        )
      })
    };

    const showError = (message) => {
      enqueueSnackbar(message, {
        variant: "error",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <CloseIcon 
            type="button"
            aria-label="Close"
            className="clickable"
            onClick={() => closeSnackbar(key)} />
        )
      })
    };

    return (
      <WrappedComponent {...props} successToast={showSuccess} errorToast={showError} />
    );
  };
};
